import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import FullSizeIcon from "~/assets/icons/FullSizeIcon";
import ArrowLeftIcon from "~/assets/icons/ArrowLeftIcon";
import ArrowRightIcon from "~/assets/icons/ArrowRightIcon";
import Slider from "~/rs-components/Slider.client";
import ShareIcon from "~/assets/icons/ShareIcon";
import { sharedButtons } from "../../../../setup/settings/__product";
import SetupSectionSharedButtons from "../../../../setup/components/setup/productDetail/SetupSectionSharedButtons.client";
import { ImageItem } from "~/types";

interface ProductImageProps {
    activeImage?: string;
    setActiveImage: (s: string) => void;
    images: ImageItem[];
    setShowImage: (b: boolean) => void;
    product: any;
}

export default function ProductImage({ activeImage, setActiveImage, images, setShowImage, product }: ProductImageProps) {

    const [[page, direction], setPage] = useState([0, 0]);
    const [activePosition, setActivePosition] = useState(0);
    const paginate = (newDirection: number) => {
        if (newDirection == 1) nextActiveImage()
        if (newDirection == -1) backActiveImage();
        setPage([page + newDirection, newDirection]);
    };

    const changeActiveImage = (image: ImageItem, i: number) => {
        if (image != null) {
            setActiveImage(image.Src);
            if (i >= 0 && i <= images.length - 1) setActivePosition(i);
        }
    }

    const nextActiveImage = () => {
        if (images.length > 0) {
            let newPosition = activePosition + 1;
            if (activePosition == images.length - 1) newPosition = 0;
            setActivePosition(newPosition);
            changeActiveImage(images[newPosition], newPosition);
        }
    }

    const backActiveImage = () => {
        let newPosition = activePosition - 1;
        if (activePosition == 0) newPosition = images.length + 1;
        setActivePosition(newPosition);
        changeActiveImage(images[newPosition]);
    }

    const variantCarr = {
        enter: (direction: number) => {
            return {
                x: direction > 0 ? 100 : -100,
                opacity: 0
            };
        },
        center: {
            zIndex: 1,
            x: 0,
            opacity: 1
        },
        exit: (direction: number) => {
            return {
                zIndex: 0,
                x: direction < 0 ? 100 : -100,
                opacity: 0
            };
        }
    };

    return (
        <div className="product-info">
            <AnimatePresence initial={false} custom={direction}>
                <div className="carrousel">
                    <motion.img
                        src={activeImage}
                        width="100%"
                        height="100%"
                        key={page}
                        custom={direction}
                        variants={variantCarr}
                        initial="enter"
                        animate="center"
                        exit="exit"
                        transition={{
                            x: { type: "spring", stiffness: 300, damping: 30 },
                            opacity: { duration: 0.5 }
                        }}
                    />
                    <span className="full-size cross circle" onClick={() => setShowImage(true)}><FullSizeIcon /></span>
                    <div className="arrow-left circle" onClick={() => paginate(-1)}><ArrowLeftIcon /></div>
                    <div className="arrow-right circle" onClick={() => paginate(1)}><ArrowRightIcon /></div>
                </div>
            </AnimatePresence>

            <div className="section-product-image-slider">
                <Slider header={undefined} footer={undefined} timeInfinitScroll={0} classMaxWidth="slider-products" slow={0} >
                    {images && images.map((image, i) =>
                        <div key={i} className={`div-slider-products ${activePosition === i ? "image-selected" : ""}`} onClick={() => changeActiveImage(image, i)}>
                            {images[i] && <img className="image-products" src={image.ThumbnailSrc} />}
                        </div>
                    )}
                </Slider>
            </div>
            {sharedButtons.enabled && <SetupSectionSharedButtons product={product} />}
        </div>
    )
}